__turbopack_context__.v({
  "cookiesButton": "Gev0Vq_cookiesButton",
  "navLink": "Gev0Vq_navLink",
  "navListItem": "Gev0Vq_navListItem",
  "navSecondaryList": "Gev0Vq_navSecondaryList",
  "navTitle": "Gev0Vq_navTitle",
});
